import { render, staticRenderFns } from "./quantity.vue?vue&type=template&id=219ab402&"
import script from "./quantity.vue?vue&type=script&lang=js&"
export * from "./quantity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sergey/projects/www/alfa-b2b/htdocs/local/templates/b2bportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('219ab402', component.options)
    } else {
      api.reload('219ab402', component.options)
    }
    module.hot.accept("./quantity.vue?vue&type=template&id=219ab402&", function () {
      api.rerender('219ab402', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/scripts/vue/components/catalog/quantity.vue"
export default component.exports